import { LocalAtendimento, TipoAtendimentoEnum } from 'graphql/types.generated'
import { LotacaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { OrientacaoFormModel, OrientacaoRowModel } from '../types/model-oriendacoes'
import { sortOrientacoes } from './sortOrientacoes'

export function mergeSortOrientacoes(
  orientacoesDatabase: ReadonlyArray<OrientacaoRowModel>,
  orientacoesCache: ReadonlyArray<OrientacaoFormModel>,
  sort: ReadonlyArray<string>,
  dataReferencia: Instant,
  atendimentoProfissionalId: ID,
  atendimentoId: ID,
  lotacao: LotacaoAtendimento | LotacaoFolhaRosto,
  tipoAtendimento?: TipoAtendimentoEnum,
  localAtendimento?: LocalAtendimento
): OrientacaoRowModel[] {
  const orientacoesCacheTransformadas = orientacoesCache.map((value, index) =>
    createOrientacaoFromCache(
      value,
      index,
      dataReferencia,
      atendimentoProfissionalId,
      atendimentoId,
      lotacao,
      tipoAtendimento,
      localAtendimento
    )
  )
  const orientacoesDatabaseOrdenadas = sortOrientacoes(orientacoesDatabase, sort)
  return [...orientacoesCacheTransformadas, ...orientacoesDatabaseOrdenadas]
}

function createOrientacaoFromCache(
  orientacaoCache: OrientacaoFormModel,
  index: number,
  dataReferencia: Instant,
  atendimentoProfissionalId: ID,
  atendimentoId: ID,
  lotacao: LotacaoAtendimento | LotacaoFolhaRosto,
  tipoAtendimento?: TipoAtendimentoEnum,
  localAtendimento?: LocalAtendimento
): OrientacaoRowModel {
  return {
    cacheId: index,
    editingId: orientacaoCache.editingId,
    descricao: orientacaoCache.descricao,
    atendimentoProfissional: {
      id: atendimentoProfissionalId,
      iniciadoEm: dataReferencia,
      lotacao,
      tipoAtendimento,
      atendimento: {
        id: atendimentoId,
        localAtendimento: localAtendimento,
      },
    },
  }
}
